<h1 [ngClass]="theme" [routerLink]="['/about']">T.E.R. Yarally</h1>

